import { CountryInfo } from '@sharedModule/models/country.model';

export const DESTINATION_COUNTRY_STATE = 'destinationCountries';

export interface DestinationCountryState {
  isLoading: boolean;
  data: CountryInfo[];
  sourceCurrency?: CountryInfo;
  error?: string;
}

export const initialDestinationCountryState: DestinationCountryState =
  Object.freeze({
    isLoading: false,
    data: [],
    error: '',
  });
